import { useRouter } from '@boss/hooks';
import { ColorsGrid } from '@boss/ui';

import { useContactPermissions, useFavorites } from '../../hooks';

const ColorsGridWrapper = (props: React.ComponentProps<typeof ColorsGrid>) => {
  const { favorites, toggleFavorite } = useFavorites();
  const { locale } = useRouter();
  // [39787] Non-cumulative heart rule: hide only when BOTH permissions are false; fail-open.
  const { showprice = true, canorder = true } = useContactPermissions(locale) ?? {};
  const hideHeart = showprice === false && canorder === false;

  return (
    <ColorsGrid
      {...props}
      colors={props.colors}
      favoriteColorIds={favorites.COLORS}
      onFavorite={hideHeart ? undefined : color => toggleFavorite('COLORS', color.code.toString(), color)}
    />
  );
};

export default ColorsGridWrapper;
